/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */



/* Klaviyo Added to Cart for Product Card */
 $(function(){
    var _learnq = window._learnq || [];
  $('.product-card__quick-add-button').each(function(){
    $(this).click(function(){

      var product_title = $(this).data('title');
      var product_id = $(this).data('pid');
      var product_img = 'https:'+$(this).data('img');
      var product_url = 'https://andrepeat.co'+$(this).data('url');
      var product_price = $(this).data('price');

      console.log(product_title);

      var item = {
        Name: product_title,
        ProductID: product_id,
        Categories: "" ,
        ImageURL: product_img,
        URL: product_url,
        Brand: "",
        Price: product_price,
        CompareAtPrice: "" ,
      };

      _learnq.push(['track', 'Added to Cart', item]);
      console.log(item);
 
    })
  })
 
})



/* Animated Text Slide */
$(function(){

if($('.animated-text').length > 0){
  jQuery('.animated-text').each(function(){

    var current_block =  jQuery(this);
      jQuery(current_block).find('p:first-child').addClass('active');
    
      setInterval(function(){
        if(jQuery(current_block).find('p.active:last-child').length > 0){
            jQuery(current_block).find('p.active').removeClass('active');
            jQuery(current_block).find('p:first-child').addClass('active');
        }else{
        jQuery(current_block).find('p.active').removeClass('active').next().addClass('active');
      }
    }, 2500);
    })
}
});


/* Tabs with Imags */
 /*
$(function(){
  if($('.tabs-with-images').length > 0){
    jQuery('.tabs-with-images').each(function(){
  
      var current_block =  jQuery(this);
        setInterval(function(){
          if(jQuery(current_block).find('button[aria-selected="true"]:nth-last-child(2)').length > 0){
              jQuery(current_block).find('button:first-child').trigger('click');
          }else{
              jQuery(current_block).find('button[aria-selected="true"]').next().next().trigger('click');
          }
        }, 5000);
      })
  }
})
  */

/* Stacked carousel */
$(function(){
  if($('.stacked-carousel').length > 0){
    document.addEventListener('carousel:stacked', function(event){
      setTimeout(function(){
         $('.stacked-carousel').find('.stacked-carousel-item').removeClass('is-selected');
          if($('.testimonial-grid .testimonial-item.is-selectd:first-child').length > 0){
            $(".stacked-carousel-item:first-child").addClass('.is-selected');
          }
          if($('.testimonial-grid .testimonial-item.is-selected:nth-child(2)').length > 0){
            $('.stacked-carousel-item:nth-child(2)').addClass('is-selected');
          }
    
          if($('.testimonial-grid .testimonial-item.is-selected:last-child').length > 0){
            $('.stacked-carousel-item:last-child').addClass('is-selected');
          } 
        
      }, 600)
     
    }) 
  }
})

/* Pill Sizes */
$(function(){
  if($(".pill-sizes-wrap").length > 0){

    $('.pill-dropdown').click(function(){
       $(this).toggleClass('open');
    })

    $('.pill-item').click(function(){
      $('.pill-item').removeClass('active');
      $(this).addClass('active');
      var pill_count = $(this).data('count')
      $('.pill-size-text').html(pill_count);
    })
    
  }

})

/* Recharge Products */
$(function(){

  window.addEventListener('ReChargeWidget-loaded', () => {
    $('button.product-card__quick-add-button[type="button"]').click(function(){
       setTimeout(function(){

         var rc_p = $('.quick-buy-modal .subscription-radio .rc-radio__price').text().trim();
         $('.quick-buy-modal .btn_price').html(rc_p);

         $('.quick-buy-modal .subscription-radio').click(function(){
            var rc_p = $('.quick-buy-modal .subscription-radio .rc-radio__price').text().trim();
           $('.quick-buy-modal .btn_price').html(rc_p);
         })

         $('.quick-buy-modal .onetime-radio').click(function(){
               var rc_p = $('.quick-buy-modal .btn_price').data('price');
             $('.quick-buy-modal .btn_price').html(rc_p);
         });
         
        }, 1000);
        
      })   
  });

  
    if($('.template--product').length > 0){
      console.log('inside product template if');
      setTimeout(function(){
        
        if($('.rc-widget').length > 0){
          var rc_p = $('.subscription-radio .rc-radio__price').text().trim();
           $('.btn_price').html(rc_p);
  
           $('.subscription-radio').click(function(){
              var rc_p = $('.subscription-radio .rc-radio__price').text().trim();
             $('.btn_price').html(rc_p);
           })
  
           $('.onetime-radio').click(function(){
                 var rc_p = $('.btn_price').data('price');
               $('.btn_price').html(rc_p);
           });
        }

        
      }, 500);
     
    }
 
});

/* Open Klaviyo Popup from announcement bar */
$(function(){
  $('a[href="#15popup"]').click(function(e){
    e.preventDefault();
    e.stopPropagation();
    $('.kl-teaser-SFV6M2').trigger('click');
  })
})



// Open external links in new tab
var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}

